import {
  RenderTreeNodePayload,
  Group,
  useMantineColorScheme,
} from "@mantine/core"
import { IconChevronDown } from "@tabler/icons-react"
import { useState } from "react"

export function radioNodeRenderer({
  node,
  expanded,
  hasChildren,
  elementProps,
  tree,
}: RenderTreeNodePayload) {
  const checked = tree.isNodeChecked(node.value)
  const [isHovered, setIsHovered] = useState(false)
  const { colorScheme } = useMantineColorScheme()

  const backgroundColor =
    checked && colorScheme === "light"
      ? "var(--mantine-color-blue-0)"
      : checked && colorScheme === "dark"
        ? "var(--mantine-color-blue-9)"
        : isHovered && colorScheme === "light"
          ? "var(--mantine-color-gray-3)"
          : isHovered && colorScheme === "dark"
            ? "var(--mantine-color-dark-7)"
            : undefined

  return (
    <Group gap="xs" {...elementProps}>
      <Group
        gap={5}
        onClick={() =>
          hasChildren
            ? tree.toggleExpanded(node.value)
            : !checked
              ? tree.setCheckedState([node.value])
              : tree.uncheckNode(node.value)
        }
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          cursor: "pointer",
          flex: 1,
          backgroundColor,
          borderRadius: "4px",
          padding: "4px",
          transition: "background-color 150ms ease",
        }}
      >
        <span style={{ fontWeight: checked ? 600 : 400 }}>{node.label}</span>

        {hasChildren && (
          <IconChevronDown
            size={14}
            style={{ transform: expanded ? "rotate(180deg)" : "rotate(0deg)" }}
          />
        )}
      </Group>
    </Group>
  )
}
